// src/utils/invoiceTaxRows.js — taxrow-4c8e1a72 (BACKLOG row 33)
// The tax rows under Subtotal on the web invoice page.
//
// WHY: the page builds its tax rows from each LINE's own tax label and rate, while the Grand Total
// beside them — and the PDF, the email and the customer portal — read the tax STORED on the
// invoice. When the two disagree the page contradicted itself: mobile "Complete & Invoice" stamped
// every line with a blank label at rate 0, so its invoices read "Tax (0%): $0.00" above a total
// that included 13% tax.
//
// RULE: if the rows built from the lines add up to the invoice's stored tax (within a cent), they
// are shown untouched. If they don't, and the stored figures themselves add up (subtotal + tax =
// total), ONE row with the stored tax is shown instead — the figure every other document shows.
// Display only: nothing here changes an invoice.

const money = (v) => (v !== null && v !== undefined && v !== '' && Number.isFinite(Number(v)) ? Number(v) : null);
const CENT = 0.015; // one cent, with room for binary rounding

/**
 * rows: { "HST ON": 13, ... } as built from the lines. invoice: the invoice record.
 * → the rows to show (the same object when nothing needs correcting).
 */
function reconcileTaxRows(rows, invoice) {
    const built = rows && typeof rows === 'object' ? rows : {};
    const stored = money(invoice && invoice.taxAmount);
    if (stored === null) return built; // no stored tax to compare with
    const sum = Object.values(built).reduce((t, v) => t + (Number(v) || 0), 0);
    if (Math.abs(sum - stored) < CENT) return built;
    const subtotal = money(invoice.subtotal); const total = money(invoice.total);
    if (subtotal === null || total === null || Math.abs(subtotal + stored - total) >= CENT) return built; // the stored figures don't add up either: leave the page as it was
    const rate = money(invoice.taxRate);
    return { [stored > 0 && rate !== null && rate > 0 ? `Tax (${rate}%)` : 'Tax']: stored };
}

export { reconcileTaxRows };
